






























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { Location } from "vue-router";
import { ROUTE_NAMES } from "../../router/routenames";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";

import { api as userApi } from "../../store/modules/user";
import { SignupUserPayload } from "../../store/modules/user/types";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoLogin extends Vue {
  avatarNo = 1;

  username = "";
  email = "";
  password = "";
  passwordConfirm = "";
  loading = false;
  error = "";
  loginRoute: Location = {
    name: ROUTE_NAMES.LOGIN,
  };
  get valid() {
    return (
      this.username.trim() !== "" &&
      this.email.trim() !== "" &&
      this.password.trim().length > 8 &&
      this.password === this.passwordConfirm
    );
  }

  get prevAvatarId() {
    return (this.avatarNo - 1).toString().padStart(3, "0");
  }
  get avatarId() {
    return this.avatarNo.toString().padStart(3, "0");
  }

  get nextAvatarId() {
    return (this.avatarNo + 1).toString().padStart(3, "0");
  }

  @Action(userApi.actions.signup, { namespace: userApi.namespace })
  signupUser!: (payload: SignupUserPayload) => Promise<any>;

  async sendSignup() {
    this.loading = true;
    try {
      console.log("signupUser");
      await this.signupUser({
        username: this.username.trim(),
        email: this.email.trim(),
        password: this.password.trim(),
        avatarId: this.avatarId,
      });
      this.$router.push({
        name: ROUTE_NAMES.LOBBY,
      });
    } catch (err) {
      console.error(err);
      this.error = err;
    }
    this.loading = false;
  }
  nextAvatar() {
    if (this.avatarNo < 100) {
      this.avatarNo += 1;
    }
  }

  prevAvatar() {
    if (this.avatarNo > 1) {
      this.avatarNo -= 1;
    }
  }
}
